export const META_TITLE_SUFFIX = ' | Bruce Studios'

export const DEFAULT_META = {
  en: {
    TITLE: 'All training. One membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
  },
  sv: {
    TITLE: 'All training. One membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
  },
  nb: {
    TITLE: 'All training. One membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
  },
  da: {
    TITLE: 'All training. One membership.',
    DESCRIPTION:
      'Get access to more than 1000 gyms, yoga studios, climbing centers, dance classes, HIIT boxes & swimming pools.',
  },
} as const
